import { StandardTextFieldProps, TextField as MuiTextField } from '@mui/material';
import { useTextFieldStyles } from './text-field.styles';
import clsx from 'clsx';
import { ReactNode } from 'react';

type TextFieldSlotProps = NonNullable<StandardTextFieldProps['slotProps']>;

export type TextFieldVariant = 'floating' | 'primarySolid' | 'secondarySolid' | 'outlined';
export interface TextFieldVariantProps {
  variant: TextFieldVariant;
  desktopWidth?: string;
  condensed?: boolean;
}

export interface TextFieldProps extends StandardTextFieldProps {
  textFieldVariant: TextFieldVariant;
  placeholder: string;
  desktopWidth?: string;
  shrinkLabel?: boolean;
  textColorOverride?: string;
  condensed?: boolean;
  startAdornment?: ReactNode;
}

export function TextField({
  textFieldVariant = 'floating',
  shrinkLabel,
  desktopWidth,
  placeholder,
  className,
  textColorOverride,
  condensed = false,
  startAdornment,
  slotProps,
  ...props
}: TextFieldProps) {
  const classes = useTextFieldStyles({ variant: textFieldVariant, desktopWidth, condensed: condensed });
  const slots = (slotProps ?? {}) as Record<keyof TextFieldSlotProps, Record<string, any> | undefined>;
  const textColorStyle = textColorOverride ? { color: textColorOverride } : {};

  return (
    <MuiTextField
      key={placeholder}
      label={
        shrinkLabel === false && props.value !== '' && props.value !== null && props.value !== undefined
          ? ''
          : placeholder
      }
      variant={textFieldVariant === 'floating' ? 'standard' : 'outlined'}
      className={clsx(
        className,
        ...[
          props.value !== '' && props.value !== null && props.value !== undefined
            ? classes.solidTextFieldInUse
            : undefined
        ],
        classes.solidTextFieldHover,
        classes.floatingTextFieldHover,
        classes.textFieldWidth
      )}
      {...props}
      // A caller's slotProps win over these defaults, except that class names are combined.
      slotProps={{
        input: {
          startAdornment,
          ...slots.input,
          className: clsx(classes.textField, slots.input?.className),
          style: { ...textColorStyle, ...slots.input?.style }
        },
        htmlInput: slots.htmlInput,
        inputLabel: {
          shrink: shrinkLabel,
          ...slots.inputLabel,
          className: clsx(classes.textFieldLabel, slots.inputLabel?.className),
          style: { ...textColorStyle, ...slots.inputLabel?.style }
        },
        select: slots.select
      }}
    />
  );
}
